import { formatDate, truncateText } from './formatters'
import moment from 'moment'
import _ from 'lodash'

export const functionalitiesHelper = {
  insertContentInArray (array, content) {
    if (array === undefined || array === null || content === undefined || content === null) return array
    if (array.includes(content) === true) return
    if (content instanceof Array) {
      if (array.length) {
        const newArray = content.filter(item => {
          return array.indexOf(item) === -1
        })
        return array.concat(newArray)
      } else {
        return array.concat(content)
      }
    } else {
      const arrayMapped = Object.assign([], array)
      arrayMapped.push(content)
      return arrayMapped
    }
  },
  removeContentInArray (array, content) {
    if (array === undefined || array === null || content === undefined || content === null) return array
    if (content instanceof Array) {
      return array.splice()
    } else {
      const contentIndex = array.indexOf(content)
      if (contentIndex === undefined || contentIndex === null || contentIndex === -1) return array
      const arrayMapped = Object.assign([], array)
      if (arrayMapped.includes('Selecionar todos')) {
        arrayMapped.splice(contentIndex, 1)
        const filterArrayMapped = arrayMapped.filter(item => item !== 'Selecionar todos')
        return filterArrayMapped
      } else {
        arrayMapped.splice(contentIndex, 1)
        return arrayMapped
      }
    }
  },
  sortObjArrayByValue (arr, value, tiebreak) {
    return arr.slice().sort((a, b) =>
      b[value] !== a[value] ? b[value] - a[value] : tiebreak ? a[tiebreak].localeCompare(b[tiebreak]) : 0)
  },
  getDates (date) {
    return {
      monthAndYear: formatDate({ date, format: 'MMMM, YYYY', capitalizeMonth: true }),
      day: formatDate({ date, format: 'DD' }),
      month: formatDate({ date, format: 'M' }),
      year: formatDate({ date, format: 'YYYY' }),
      fullDate: formatDate({ date, format: 'YYYY-MM-DD' }),
      startDate: formatDate({ date: moment(date).startOf('month'), format: 'YYYY-MM-DD' })
    }
  }
}

export const isSameOrBeforeDate = (array, date) => {
  return array.filter(item => {
    const isSameOrBeforeCurrentDate = moment(item.day).isSameOrBefore(moment(date))
    return isSameOrBeforeCurrentDate
  })
}

export const addObjArrayValues = (objArray, key) => objArray.reduce((prev, curr) => prev + curr[key], 0)

export const getLabelAndValue = (objArray, labelKey, valueKey, ranked = false, truncate = 0, decorator) => {
  return objArray.map((item, index) => {
    return {
      label: truncate > 0 ? truncateText(item[labelKey], truncate) : item[labelKey],
      value: ranked ? index + 1 : item[valueKey],
      decorator
    }
  })
}

export const arraySortAlphabetical = (arr) => _.sortBy(arr, [item => _.deburr(item).toLowerCase()])

export const validateEmail = (email) => {
  const regexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi
  return regexExp.test(email)
}

export function generatePhoneMask (inputValue) {
  const numericValue = inputValue.replace(/\D/g, '') // Remove caracteres não numéricos
  const maxCharacters = 11 // 2 dígitos para o código de área e 9 dígitos para o número principal

  if (numericValue.length > maxCharacters) {
    // Não permita mais caracteres do que o formato da máscara
    return numericValue.substring(0, maxCharacters).replace(/^(\d{2})(\d{0,5})(\d{0,4})$/, '($1) $2-$3')
  }

  const formattedValue = numericValue.replace(/^(\d{2})(\d{0,5})(\d{0,4})$/, '($1) $2-$3')
  return formattedValue
}

export const compareFields = (fieldsA, fieldsB) => {
  try {
    return fieldsA
      .map((field, index) => field?.localeCompare(fieldsB[index]))
      .find(cmpResult => cmpResult !== 0) || 0
  } catch (e) {
    console.log('error')
  }
}

export const isMobile = () => {
  return typeof window !== 'undefined' ? window.innerWidth <= 768 : false
}
